import styled from 'styled-components';
import Box from '@rsos/components/capstone/base/Box';

export const CopyButton = styled(Box).attrs(({ isActive }) => ({
  position: 'relative',
  horizontal: true,
  align: 'center',
  justify: 'center',
  backgroundColor: isActive && 'lightLineDivider',
  width: '65px',
  marginLeft: '3px',
  padding: '5px',
  color: 'secondaryLink',
  cursor: 'pointer',
  transition: 'background-color 0.3s',
}))`
  border-radius: 5px;
  &:hover {
    background-color: ${({ theme }) => theme.colors.lightLineDivider};
  }
`;
